/*
  Local JSON:API deserializer.

  Replaces deserialize-json-api to avoid a bug where the JSON:API resource
  `type` (e.g. "layers") overwrites the attribute `type` (e.g. "raster"),
  which breaks layer-manager.
*/

const findIncluded = (included: any[], type: string, id: string) => {
  return included.find((item: any) => item.type === type && item.id === id);
};

const deserializeResource = (resource: any, included: any[]): any => {
  if (!resource) return null;

  const { id, attributes = {}, relationships = {} } = resource;
  const deserialized: any = { id, ...attributes };

  Object.keys(relationships).forEach((key) => {
    const relationship = relationships[key].data;
    if (!relationship) return;

    if (Array.isArray(relationship)) {
      deserialized[key] = relationship.map((rel: any) => ({
        id: rel.id,
        ...deserializeResource(
          findIncluded(included, rel.type, rel.id),
          included
        ),
      }));
    } else {
      deserialized[key] = {
        id: relationship.id,
        ...deserializeResource(
          findIncluded(included, relationship.type, relationship.id),
          included
        ),
      };
    }
  });

  return deserialized;
};

export const deserialize = (response: any) => {
  // A non-empty body that is not JSON (e.g. a gateway HTML error page on a 200)
  // must fail here rather than surface as an empty resource downstream.
  if (response && typeof response !== "object") {
    throw new Error("Unexpected non-JSON:API response body");
  }
  if (!response?.data) return null;

  const { included = [] } = response;

  return Array.isArray(response.data)
    ? response.data.map((resource: any) =>
        deserializeResource(resource, included)
      )
    : deserializeResource(response.data, included);
};
